module.exports = __webpack_public_path__ + "static/media/bat4.12666714.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/bat4.png
// module id = 472
// module chunks = 0